import { render, staticRenderFns } from "./CustomWidget.vue?vue&type=template&id=270cff41&scoped=true"
import script from "./CustomWidget.vue?vue&type=script&lang=js"
export * from "./CustomWidget.vue?vue&type=script&lang=js"
import style0 from "./CustomWidget.vue?vue&type=style&index=0&id=270cff41&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270cff41",
  null
  
)

export default component.exports